<div>
    <div
        class="mr-3"
        [attr.data-pillar]=""
    >
        {{ pillarName }}
    </div>
    <div
        class="cmps-cdk-border-l-width-1px cmps-cdk-border-l-solid cmps-cdk-border-l-color-grey-300 insight-separator"
    ></div>
    <div
        class="mr-5"
        [attr.data-metric]=""
    >
        {{ metricName }}
    </div>
    <div
        class="d-flex mr-5 cmps-cdk-align-items-center"
        *ngIf="dataMetric"
    >
        <div
            class="insight-actual"
            [style.color]="
                showThresholdColours === true
                    ? dataMetric.targetThresholdColor
                    : null
            "
        >
            {{
                dataMetric.actual == null
                    ? '-'
                    : (dataMetric.actual | cmpsNumber: '1.1-2')
            }}
        </div>
        <div class="progress insight-gauge">
            <div
                class="progress-bar insight-gauge-fill"
                [class.insight-metric-bold]="
                    showThresholdColours === true &&
                    dataMetric.targetThresholdBold === true
                "
                [style.width]="localState.width + '%'"
                [style.background-color]="
                    showThresholdColours === true
                        ? dataMetric.targetThresholdColor
                        : null
                "
                role="progressbar"
                [attr.aria-valuenow]="localState.width"
                aria-valuemin="0"
                aria-valuemax="100"
            ></div>
        </div>
        <span
            class="sr-only"
            *ngIf="showThresholdColours === true"
        >
            {{ dataMetric.targetThresholdName }}
        </span>
        <ng-container
            *ngIf="
                showTrendArrows === true &&
                dataMetric.trendClass?.split(' ')?.length > 1
            "
        >
            <cmps-icon
                [style.fill]="dataMetric.trendClass.split(' ')[0]"
                [svgIcon]="
                    dataMetric.trendClass
                        .split(' ')[1]
                        .toLowerCase()
                        .includes('up')
                        ? 'chevron-up'
                        : dataMetric.trendClass
                              .split(' ')[1]
                              .toLowerCase()
                              .includes('down')
                        ? 'chevron-down'
                        : null
                "
            ></cmps-icon>
            <span class="sr-only">
                {{ dataMetric.trendName }}
            </span>
        </ng-container>
    </div>
</div>
